module.exports = __webpack_public_path__ + "static/k-3264df621a9b4df52c640c5ef98cd730.jpg";